import { Injectable } from "@angular/core";
import { ReplaySubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class HomeReadyService {

  private _homeready: ReplaySubject<void> = new ReplaySubject<void>();
  constructor() { }

  /** Observable that fires once, either when the home.component has fully loaded or already has*/
  public get homeready(): Observable<void> {
    return this._homeready.asObservable();
  }

  /** Triggers HomeReady Subject, executed by HomeComponent when it has loaded data */
  public triggerHomeReady() {
    this._homeready.next();
  }

}
